import {TimelineMax} from 'gsap';
const PIXI = require('pixi.js');
const Shortcuts = require('../utils/Shortcuts');


const _addView = instance => {
    const cont = new PIXI.Container();
    const sizes = require('../../DefaultProjectSize');


    const overlay = new PIXI.Graphics();
    Shortcuts.rect(overlay, 0, 0, sizes.width, sizes.height, 0x000000);
    overlay.alpha = 0;

    cont.addChild(overlay);

    instance.cont = cont;
    instance.width = sizes.width;
    instance.height = sizes.height;
    instance.overlay = overlay;

    instance.root.addChild(cont);
}

const _removeView = instance => {
    if (instance.cont.parent)
        instance.cont.parent.removeChild(instance.cont);
}


const _constructTimeline = instance => {
    const tl = new TimelineMax({paused: true});
    const d1 = 2.4 + 0.4, d2 = 4;

    tl.set(instance.overlay, {alpha: 0}, 'in');

    tl.to(instance.overlay, d1 - 0.4, {alpha: 1}, 'in+=' + 0.4);
    tl.to(instance.overlay, d2, {alpha: 0}, 'out');

    instance.timeline = tl;
    return tl;
}


function FadeTransition(app, root) {

    const constructor = {};
    let _created = false;

    constructor.create = () => {
        if (_created) return constructor.instance.timeline;
        const instance = {
            app: app,
            root: root
        };
        _addView(instance);

        constructor.instance = instance;
        _created = true;

        return _constructTimeline(constructor['instance']);
    };

    constructor.destroy = () => {
        if (!_created) return;

        // Delete all the links
        const instance = constructor['instance'];
        Shortcuts.destroyTimeline(instance);
        _removeView(instance);
        constructor.instance = null;

        _created = false;
    };

    constructor.startDuration = 2.8;
    constructor.totalDuration = 6.8;

    return constructor;
}


module.exports = FadeTransition;



// WEBPACK FOOTER //
// ./js/viscom/vereschagin/timelines/transitions/FadeTransition.js